/**
 * Sends a tapped block action (an `intent` string) as a plain NEW user turn.
 * It remains a plain visitor utterance rather than an api.dispatch action,
 * while naming the surface where the visitor tapped it for continuation.
 * A standalone reader without a surface API cannot submit a conversation turn.
 */
import { useContext } from 'react';
import { A2uiSurfaceContext } from '../surface-context.ts';

export function useSendIntent(): (intent: string) => void {
  const surface = useContext(A2uiSurfaceContext);
  return (intent: string) => {
    if (!intent) {
      return;
    }
    surface?.sendIntent(intent);
  };
}
